import styled from 'styled-components';
import { ColorSelectStyled } from '../ColorSelectStyled';
import { rem } from 'polished';

export const ColorSelectStyledOV = styled(ColorSelectStyled)`
    .name {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
    }

    .colorButton {
        &.is-selected {
            box-shadow: 0px 0px 0px 0.15rem ${({ theme }) => theme.colors.black};
        }

        &.enabled {
            &:hover,
            &:focus-visible {
                box-shadow: 0px 0px 0px 0.15rem ${({ theme }) => theme.colors.black};
            }
        }
    }
`;
